var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53146 3.17969C6.59812 3.17969 3.07812 6.11302 3.07812 10.8064C3.07812 15.4997 6.59813 19.0197 11.2915 19.0197C15.9848 19.0197 18.9181 15.4997 18.9181 12.5664C12.4648 16.673 5.42479 9.63302 9.53146 3.17969Z",
    stroke: "#4678EC",
    strokeWidth: 1.17333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "static/media/after_evening.c17138ed.svg";
export { SvgComponent as ReactComponent };